import React from "react";
import Poster from "../Poster/Poster";
import Category from "./Category";

const SingleCategory = () => {
  return (
    <>
      <Poster />
      <Category/>
    </>
  );
};

export default SingleCategory;
